
  // Set by a live navigation to another page, which LiveView announces before the new page's hooks
  // mount, and cleared once that page has joined, so only a bar mounted by the navigation takes focus.
  let navigated = false
  window.addEventListener("phx:navigate", e => { navigated = !e.detail.patch })
  window.addEventListener("phx:page-loading-stop", e => {
    if (e.detail.kind === "initial") navigated = false
  })

  export default {
    mounted() {
      if (navigated) this.el.querySelector('[aria-current="page"]')?.focus()
      navigated = false
    }
  }
